import { QUERY_CHANNELS } from '~/app/state/queries'
import type { LabelCount } from '~/gql/graphql'
import type { MergedChannel } from '~/modules/account/types'
import { setCachedData } from '~/shared/utils'

export default async function setChannels(
  _: unknown,
  { channels }: { channels: Partial<MergedChannel>[] },
  { client }: { client: any },
): Promise<void> {
  const normalizedChannels = channels.map((channel) => {
    // Default label counts if none provided
    const defaultLabelCounts: LabelCount[] = [
      {
        __typename: 'LabelCount',
        label: 'NEGATIVITY',
        count: 0,
      },
      {
        __typename: 'LabelCount',
        label: 'ORDER',
        count: 0,
      },
      {
        __typename: 'LabelCount',
        label: 'QUESTION',
        count: 0,
      },
    ]

    // return merged channel, with default values for missing fields
    return {
      __typename: 'MergedChannel',
      totalComments: channel.totalComments ?? 0,
      totalPendingComments: channel.totalPendingComments ?? 0,
      labelsCount: channel.labelsCount || defaultLabelCounts,
      updatedAt: channel.updatedAt ?? new Date().toISOString(),
      ...channel,
    }
  })

  setCachedData(client, {
    query: QUERY_CHANNELS,
    data: { channels: normalizedChannels },
  })
}
